'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_attention: 'Atenção!',
    modal_error_birthday: 'Data de nascimento inválida',
  },
  en: {
    modal_attention: 'Attention!',
    modal_error_birthday: 'Invalid birth date',
  },
  es: {
    modal_attention: '¡Atención!',
    modal_error_birthday: 'Fecha de nacimiento no válida',
  },
};

const helpers = {
  trackError() {
    const link = href => window.document.createElement('a').href;

    window.onerror = function (message, file, line, column) {
      const host = link(file).hostname;
      ga('send', {
        hitType: 'event',
        eventCategory:
          (host == window.location.hostname || host == undefined || host == '' ? '' : 'external ') + 'error',
        eventAction: message,
        eventLabel: (file + ' LINE: ' + line + (column ? ' COLUMN: ' + column : '')).trim(),
        nonInteraction: 1,
      });
    };
  },

  dateValidate() {
    let dateFrom = '01/01/1900';
    let today = new Date();
    let dateTo = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
    let dateCheck = $('.js-form-date').val();
    let d1 = dateFrom.split('/');
    let d2 = dateTo.split('/');
    let c = dateCheck.split('/');
    let from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]);
    let to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0]);
    let check = new Date(c[2], parseInt(c[1]) - 1, c[0]);

    if (check == 'Invalid Date' || parseInt(c[1]) - 1 > 11 || c[0] > 31 || check < from || check > to) {
      Swal.fire(tr[lang].modal_attention, tr[lang].modal_error_birthday, 'error');
      return false;
    }
  },

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
};

export const trackError = helpers.trackError;
export const dateValidate = helpers.dateValidate;
export const isValidEmail = helpers.isValidEmail;
